import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import firebase from "firebase/app";

//ヘッダーを非表示が難しかった為、ヘッダー表示を制御するようにする
import HeaderComponents from './components/Header.vue'
//直書き
//const Baz = { template: '<div>baz</div>' }

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      //component: Home 一つの場合はこちらでOK
      components: {
        default: Home,
        Header: HeaderComponents,
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        Header: HeaderComponents,
      },

      meta: { requiresAuth: true }
    },

    {
      path: '/inputprogram',
      name: 'inputprogram',
      //      component: () => import('./views/InputProgram.vue'),
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/InputProgram.vue'),
        Header: HeaderComponents,
      },
      meta: { requiresAuth: true }
    },

    {
      path: '/inputprogramlist',
      name: 'inputprogramlist',
      //component: () => import('./views/InputProgramList.vue'),
      components: {
        default: () => import('./views/InputProgramList.vue'),
        Header: HeaderComponents,
      },

      meta: { requiresAuth: true }
    },

    {
      path: '/programnotification',
      name: 'programnotification',
      components: {
        default: () => import('./views/ProgramNotification.vue'),
        Header: HeaderComponents,
      },

      meta: { requiresAuth: true }
    },


    {
      path: '/usernotification',
      name: 'usernotification',
      //Headerを表示しない
      component: () => import('./views/UserNotification.vue'),
    },

    {
      path: '/viewqr',
      name: 'viewqr',
      default: () => import('./views/ViewQR.vue'),
      components: {
        default: () => import('./views/ViewQR.vue'),
        Header: HeaderComponents,
      },

      meta: { requiresAuth: true }
    },


    {
      path: '/signin',
      name: 'signin',
      components: {
        default: () => import('./views/Signin.vue'),
        Header: HeaderComponents,
      },
    },

    {
      path: '/signout',
      name: 'signout',
      components: {
        default: () => import('./views/Signout.vue'),
        Header: HeaderComponents,
      },

    },

    //お問い合わせ
    {
      path: '/contact',
      name: 'contact',
      components: {
        default: () => import('./views/Contact.vue'),
        Header: HeaderComponents,
      }
    },

    {
      path: '/supportpage123',
      name: 'supportpage123',
      //component: () => import('./views/InputProgramList.vue'),
      components: {
        default: () => import('./views/SupportPage123.vue'),
        Header: HeaderComponents,
      },

      meta: { requiresAuth: true }
    },


    {
      path: '*',
      component: () => import('./views/NotFoundComponent.vue')
    },

    // {
    //   path: '/emailverified',
    //   name: 'emailverified',
    //   component: () => import('./views/EmailVerified.vue')
    // },


  ]
})

//https://qiita.com/sin_tanaka/items/ea149a33bd9e4b388241コピペ

//こちらにするとログイン情報が変更になった場合感知されないので却下
// router.beforeEach((to, from, next) => {
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

//   if (requiresAuth) {
//     // このルートはログインされているかどうか認証が必要です。
//     // もしされていないならば、ログインページにリダイレクトします。
//     let currentUser = firebase.auth().currentUser
//     if (!currentUser) {
//       next({
//         path: '/signin',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next() // next() を常に呼び出すようにしてください!
//   }
// })

//勝手に拡張
router.IsSignout = false;

router.beforeEach((to, from, next) => {

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  let currentUser = firebase.auth().currentUser;

  if (requiresAuth && currentUser != null) {
    mailSend(currentUser, to, next);
  }
  else if (requiresAuth && currentUser == null) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        mailSend(user, to, next);
      } else {

        //ログオフページに強制移動
        if (router.IsSignout == true) {
          router.IsSignout = false;
          next({
            path: '/signout',
          });
        }
        else {
          next({
            path: '/signin',
            query: { redirect: to.fullPath }
          });
        }
      }
    })
  } else {
    next(); // next() を常に呼び出すようにしてください!
  }
})

function mailSend(user, to, next) {

  //email承認済み
  if (user.email == null || user.emailVerified == true) {
    next();
    return;
  }

  user.sendEmailVerification()
    .then(() => {
      alert(`${user.email}宛に確認メールを送信しました。メール認証後再度ログインしてください。`);

      next({
        path: '/signout',
        query: { redirect: to.fullPath }
      });

    })
    .catch(error => {
      alert(`${user.email}宛に確認メールを送信できませんでした: ${error}`);

      next({
        path: '/signout',
        query: { redirect: to.fullPath }
      });

    });
}

export default router;